import { IServices } from "@netent/origin";
import { PlayUIListenerCreator } from "../../types";

export const onQuickSpinChangeRequest: PlayUIListenerCreator = (
  services: IServices
) => (enable: boolean) => {
  services.gameSettings.setSetting({
    id: "quickSpin",
    value: enable,
    persistent: true
  });
};
